// Column definitions for the Presales table
export const COLUMN_DEFINITIONS = {
  like: {
    key: 'like',
    title: 'Like',
    width: 'w-[45px]',
    sortable: true,
    sortField: 'like',
    sortAscendingDefault: false,
    headerClassName: 'justify-center',
    alwaysVisible: true, // This column should always be visible
  },
  image: {
    key: 'image',
    title: '',
    width: 'w-[50px]',
    sortable: true,
    sortField: 'designation',
    sortAscendingDefault: false,
    headerClassName: 'justify-center',
    alwaysVisible: true, // Car image should always be visible
  },
  carId: {
    key: 'carId',
    title: '#',
    width: 'w-[45px] 2xl:w-[45px]',
    sortable: true,
    sortField: 'car_id',
    sortAscendingDefault: true,
  },
  description: {
    key: 'description',
    title: 'Description',
    width: 'w-[120px] 2xl:w-[250px]',
    sortable: true,
    sortField: 'designation',
    sortAscendingDefault: true,
  },
  status: {
    key: 'status',
    title: 'Status',
    width: 'w-[110px]',
    sortable: true,
    sortField: 'buy_status',
    sortAscendingDefault: true,
    headerClassName: 'pl-[30px]',
  },
  location: {
    key: 'location',
    title: 'Location',
    width: 'w-[100px]',
    sortable: true,
    sortField: 'stock_location',
    sortAscendingDefault: true,
    responsiveClass: 'hidden 2xl:block',
  },
  firstReg: {
    key: 'firstReg',
    title: 'First Reg.',
    width: 'w-[100px]',
    sortable: true,
    sortField: 'reg_date',
    sortAscendingDefault: true,
    headerClassName: '',
    textAlignment: 'text-center',
  },
  km: {
    key: 'km',
    title: 'Km',
    width: 'w-[70px]',
    sortable: true,
    sortField: 'km',
    sortAscendingDefault: true,
    headerClassName: 'justify-center',
    textAlignment: 'text-center',
  },
  damages: {
    key: 'damages',
    title: 'Damages',
    width: 'w-[80px]',
    sortable: true,
    sortField: 'damage_amount',
    sortAscendingDefault: false,
    headerClassName: 'justify-end',
    textAlignment: 'text-center',
    responsiveClass: 'hidden xl:block',
  },
  price: {
    key: 'price',
    title: 'Price',
    width: 'w-[160px]',
    sortable: true,
    sortField: 'price',
    sortAscendingDefault: true,
    headerClassName: 'justify-center',
    textAlignment: 'text-center',
    conditionalVisibility: 'hidePrices', // This column visibility depends on hidePrices prop
  },
  buy: {
    key: 'buy',
    title: 'Buy',
    width: 'w-[75px]',
    sortable: true,
    sortField: 'offer_amount',
    sortAscendingDefault: false,
    headerClassName: 'justify-center',
    textAlignment: 'text-center',
    conditionalVisibility: 'hidePrices',
  },
  offer: {
    key: 'offer',
    title: 'Offer',
    width: 'w-[120px]',
    sortable: true,
    sortField: 'offer_amount',
    sortAscendingDefault: false,
    headerClassName: 'justify-center',
    textAlignment: 'text-center',
    conditionalVisibility: 'hidePrices',
  },
  equipment: {
    key: 'equipment',
    title: 'Equipment',
    width: 'w-[160px]',
    sortable: true,
    sortField: 'equipmentBase',
    sortAscendingDefault: false,
    headerClassName: 'justify-start',
    textAlignment: 'text-center',
    responsiveClass: 'hidden screen-large:block',
  },
  horsepower: {
    key: 'horsepower',
    title: 'HP',
    width: 'w-[55px]',
    sortable: true,
    sortField: 'horsepower',
    sortAscendingDefault: true,
    headerClassName: 'justify-center',
    textAlignment: 'text-center',
    responsiveClass: 'hidden 4xl:block',
  },
  color: {
    key: 'color',
    title: 'Color',
    width: 'w-[160px]',
    sortable: true,
    sortField: 'color',
    sortAscendingDefault: true,
    headerClassName: 'justify-start',
    textAlignment: 'text-left',
    responsiveClass: 'hidden 4xl:block',
  },
  fuel: {
    key: 'fuel',
    title: 'Fuel',
    width: 'w-[160px]',
    sortable: true,
    sortField: 'fuel_name',
    sortAscendingDefault: false,
    headerClassName: 'justify-left',
    textAlignment: 'text-center',
    responsiveClass: 'hidden 4xl:block',
  },
  gear: {
    key: 'gear',
    title: 'Gear',
    width: 'w-[160px]',
    sortable: true,
    sortField: 'gear_name',
    sortAscendingDefault: false,
    headerClassName: 'justify-start',
    textAlignment: 'text-center',
    responsiveClass: 'hidden 4xl:block',
  },
};

// Predefined table configurations
export const TABLE_CONFIGURATIONS = {
  compact: {
    name: 'Compact View',
    columns: ['like', 'image', 'carId', 'description', 'status', 'price', 'buy'],
  },
  standard: {
    name: 'Standard View',
    columns: ['like', 'image', 'carId', 'description', 'status', 'location', 'firstReg', 'km', 'price', 'buy', 'offer'],
  },
  detailed: {
    name: 'Detailed View',
    columns: ['like', 'image', 'carId', 'description', 'status', 'location', 'firstReg', 'km', 'damages', 'price', 'buy', 'offer', 'equipment'],
  },
  full: {
    name: 'Full View',
    columns: ['like', 'image', 'carId', 'description', 'status', 'location', 'firstReg', 'km', 'damages', 'price', 'buy', 'offer', 'equipment', 'horsepower', 'color', 'fuel', 'gear'],
  },
  noPrices: {
    name: 'No Prices View',
    columns: ['like', 'image', 'carId', 'description', 'status', 'location', 'firstReg', 'km', 'damages', 'equipment', 'horsepower', 'color', 'fuel', 'gear'],
  },
  package: {
    name: 'Package View',
    columns: ['image', 'carId', 'description', 'status', 'location', 'firstReg', 'km', 'price', 'damages', 'equipment', 'horsepower', 'color', 'fuel', 'gear'],
  },

};

// Helper function to get columns for a configuration
export const getColumnsForConfiguration = (configName, hidePrices = false) => {
  const config = TABLE_CONFIGURATIONS[configName];
  if (!config) {
    console.warn(`Configuration '${configName}' not found. Using 'standard' configuration.`);
    return getColumnsForConfiguration('standard', hidePrices);
  }

  return config.columns
    .map(columnKey => COLUMN_DEFINITIONS[columnKey])
    .filter(column => {
      if (!column) return false;
      
      // Handle conditional visibility (like hidePrices)
      if (column.conditionalVisibility === 'hidePrices' && hidePrices) {
        return false;
      }
      
      return true;
    });
};

// Helper function to check if a column should be visible
export const isColumnVisible = (column, hidePrices = false) => {
  if (column.conditionalVisibility === 'hidePrices' && hidePrices) {
    return false;
  }
  return true;
};
